import { VueApp } from 'VueApp';

import SupersetDesigner from 'Pages/BI/Vue/SupersetDesigner.vue';

/**
 * The Superset workspace is a Vue page now; this host only exists because the
 * menu manager instantiates pages and hands them a container id.
 */
export class SupersetPage {
    private _target: HTMLElement;

    Render(targetId: string) {
        this._target = document.getElementById(targetId);
        if (!this._target) {
            return;
        }

        VueApp.Mount(SupersetDesigner, this._target);
    }

    Dispose() {
        if (this._target) {
            VueApp.UnMount(this._target);
        }
    }
}
